import React from 'react';
import './Medalii.css';


const medalii = [
  { id: 1, name: 'Bronze', unlocked: false },
  { id: 2, name: 'Silver', unlocked: false },
  { id: 3, name: 'Gold', unlocked: false },
  { id: 4, name: 'Platinum', unlocked: false },
  { id: 5, name: 'Diamond', unlocked: false },
];

export default function Medalii() {
  return (
    <div className="medalii-container">
      <div className="medalii-header">Medalii</div>
      <div className="medalii-badges">
        {medalii.map((medalie, idx) => (
          <div key={medalie.id} className={`medalie-badge${medalie.unlocked ? ' unlocked' : ' locked'}`}>
            <span role="img" aria-label="locked" className="medalie-icon">🔒</span>
            <div className="medalie-label">{medalie.name}</div>
          </div>
        ))}
      </div>
      <div className="medalii-message">Câștigă XP și finalizează provocări pentru a debloca medalii!</div>
    </div>
  );
}
